"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfViewer = void 0;
const react_1 = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const react_pdf_1 = require("react-pdf");
const DocumentSkeleton_1 = require("./DocumentSkeleton");
react_pdf_1.pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${react_pdf_1.pdfjs.version}/build/pdf.worker.min.js`;
const ThumbnailImage = Theme_1.styled.div `
  width: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  height: ${(props) => (props.size ? `${props.size}px;` : '100px;')};
  border-radius: 3px;
  z-index: 0;
  overflow: hidden;

  .react-pdf__message--error {
    font-size: 12px;
    color: #fff;
  }
  &:hover {
    opacity: 0.4;
  }
`;
const PdfViewer = (props) => {
    const initialState = { loading: true, error: false, data: null };
    function reducer(state, action) {
        switch (action.type) {
            case 'setError':
                return { error: action.value };
            case 'setLoading':
                return { loading: action.value };
            case 'setData':
                return { data: action.value };
            default:
                throw new Error();
        }
    }
    const [state, dispatch] = (0, react_1.useReducer)(reducer, initialState);
    function onLoadSuccess() {
        props.imageLoaded && props.imageLoaded(props.pdf);
    }
    function onLoadError() {
        props.imageLoadedError && props.imageLoadedError(props.pdf);
    }
    const controller = new AbortController();
    const { signal } = controller;
    const getPdfData = () => __awaiter(void 0, void 0, void 0, function* () {
        if (props.pdf.url) {
            try {
                const result = yield fetch(props.pdf.url, { signal });
                const pdfBuffer = yield result.arrayBuffer();
                dispatch({ type: 'setLoading', value: false });
                dispatch({ type: 'setData', value: pdfBuffer });
                onLoadSuccess();
            }
            catch (err) {
                dispatch({ type: 'setError', value: true });
                dispatch({ type: 'setLoading', value: false });
                onLoadError();
            }
        }
    });
    (0, react_1.useEffect)(() => {
        if (props.pdf.url)
            getPdfData();
        return () => {
            controller.abort();
        };
    }, [props.pdf.url]);
    return (react_1.default.createElement(ThumbnailImage, Object.assign({ className: "cloverThumbnailImage" }, props),
        (state === null || state === void 0 ? void 0 : state.loading) && react_1.default.createElement(DocumentSkeleton_1.DocumentSkeleton, Object.assign({}, props)),
        (state === null || state === void 0 ? void 0 : state.data) && (react_1.default.createElement(react_pdf_1.Document, { renderMode: "svg", file: state.data },
            react_1.default.createElement(react_pdf_1.Page, { width: props.size ? Number(props.size) : 100, height: props.size ? Number(props.size) : 100, pageNumber: 1 }))),
        (state === null || state === void 0 ? void 0 : state.error) && react_1.default.createElement("span", null, "Error loading file.")));
};
exports.PdfViewer = PdfViewer;
//# sourceMappingURL=PdfViewer.js.map